/**
 * 系统管理  公司管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/Home' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Beauty Center List</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="Search：">
        <el-input size="small" v-model="formInline.companyName" placeholder="Beauty Center"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" clearable v-model="formInline.editUser" placeholder="Modifier">
          <el-option v-for="(item,i) in selectData" :key="i" :label="item.editUser" :value="item.editUser"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Modification Time">
        <el-date-picker size="small" v-model="formInline.editTime" type="daterange" align="right" unlink-panels range-separator="To" start-placeholder="Start Date" end-placeholder="Ending Date" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" :loading="loading" type="primary" icon="el-icon-plus" @click="handleEdit()">Add Beauty Center</el-button>
        <el-button size="small" type="danger" @click="deleteUser('batchDelete')">Batch Delete</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="handleSelectionChange" :default-sort = "{prop: 'editTime', order: 'ascending'}" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="Loading..." style="width: 100%;">
      <el-table-column align="center" type="selection" width="60"></el-table-column>
      <el-table-column align="center" prop="companyName" label="Beauty Center" width="200"></el-table-column>
      <el-table-column align="center" prop="total" label="Machine Totals" width="200"></el-table-column>
      <el-table-column align="center" prop="user" label="Account Totals" width="200"></el-table-column>
      <el-table-column align="center" prop="editTime" label="Creation Time" width="200">
        <!-- <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template> -->
      </el-table-column>
      <el-table-column align="center" prop="editUser" label="Modifier" width="200"></el-table-column>
      <el-table-column align="center" label="Operation" fixed="right" min-width="100">
        <template slot-scope="scope">
          <el-button v-show="false" size="mini" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="Beauty Center" prop="companyName">
          <el-input size="small" v-model="editForm.companyName" auto-complete="off" placeholder="Please enter your Beauty Center"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '',
      selectData: '',
      modifierList: [],
      editForm: {
        dbName: 'beautycenter',
        companyName: '',
        total: ''
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        dbName: 'beautycenter',
        page: 1,
        companyName: '',
        editUser: '',
        editTime: ''
      },
      selectFormInline: {
        dbName: 'beautycenter',
        page: 1,
        companyName: '',
        editUser: '',
        editTime: ''
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        total: 10
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Latest week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    deptList(this.selectFormInline)
      .then(res => {
        if (res.code === 201) {
          this.selectData = res.data
        }
      })
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取美容中心列表
    getdata(parameter) {
      this.loading = true
      deptList(parameter)
        .then(res => {
          this.loading = false
          if (res.code === 201) {
            this.listData = res.data;
            // 分页赋值
            this.pageparm.page = this.formInline.page;
            this.pageparm.total = res.total;
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Menu failed to load, please try again later！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      console.log(this.formInline);
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = 'Edit'
        // this.editForm.type = 'edit';
        this.editForm.deptId = row.id
        this.editForm.companyName = row.companyName
        this.editForm.total = row.total
        this.editForm.editTime = row.editTime;
      } else {
        var myDate = new Date();
        var hour = myDate.getHours();
        myDate.setHours(hour + 2)
        var time = myDate.toISOString()
        this.title = 'Add Beauty Center'
        // this.editForm.type = 'create';
        this.editForm.companyName = '';
        this.editForm.total = 0;
        this.editForm.user = 0;
        this.editForm.editTime = time;
        this.editForm.editUser = JSON.parse(localStorage.getItem('userdata'))._source.account;
        console.log(this.editForm);
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.loading = true;
          deptSave(this.editForm)
            .then(res => {
              console.log(this.editForm);
              if (res.code === 201) {
                this.$message({
                  type: 'success',
                  message: 'Beauty center save successful！'
                })
                  setTimeout(() => {
                    this.getdata(this.formInline)
                    this.loading = false;
                    this.editFormVisible = false
                  }, 800);


              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Beauty center failed to save, please try again later！')
            })
        } else {
          return false
        }
      })
    },
    // 删除美容中心
    deleteUser(index, row) {
      var deptDelMsg = '';
      var time = 800;
      if(index !== 'batchDelete'){
        deptDelMsg = {
          dbName: 'beautycenter',
          roleId: row.id
        }
      }else{
        time = 1000;
        deptDelMsg = {
          dbName: 'beautycenter',
          type: 'batchDelete',
          roleId: this.editForm.listData
        }
      }
      this.$confirm('Are you sure you want to delete?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.loading = true;
          deptDelete(deptDelMsg)
            .then(res => {
              if (res.code === 201) {
                this.$message({
                  type: 'success',
                  message: 'The beauty center has deleted!'
                })
                setTimeout(() => {
                  this.formInline.page = 1;
                  this.getdata(this.formInline)
                  this.loading = false;
                }, time);
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('Beauty center failed to delete, please try again later！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancelled delete'
          })
        })
    },
    handleSelectionChange(data){
        var arr = [];
      for(var i=0;i<data.length;i++){
        arr.push(data[i].id);
      }
      this.editForm.listData = arr;
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Dept.vue